import { type FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSatelliteDish } from '@fortawesome/free-solid-svg-icons';

const AdaptiveFlowMonitorMock: FC = () => (
  <div className="rounded-lg overflow-hidden shadow-2xl shadow-black/30 border border-white/[0.06] font-mono" style={{ background: '#0f1923' }}>
    <div className="p-3 space-y-3">
      {/* Health & Status */}
      <div className="bg-[#181825] border border-white/[0.06] rounded-lg p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <FontAwesomeIcon icon={faSatelliteDish} className="text-sm text-emerald-400" />
            <h4 className="text-xs font-medium text-gray-400 uppercase tracking-wide">Adaptive Flow</h4>
          </div>
          <span className="flex items-center gap-1.5 px-2 py-1 rounded" style={{ background: 'rgba(16,185,129,0.1)' }}>
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
            <span className="text-[10px] text-gray-300">Active</span>
          </span>
        </div>

        <div className="grid grid-cols-4 gap-3">
          {[
            { label: 'Health Score', value: '7.4', color: 'text-emerald-400' },
            { label: 'Confidence', value: '78%', color: 'text-white' },
            { label: 'Live Trades', value: '12', color: 'text-white' },
            { label: 'Progress', value: '64%', color: 'text-cyan-400' },
          ].map((m) => (
            <div key={m.label} className="text-center">
              <div className="text-[9px] text-gray-500 uppercase tracking-wider">{m.label}</div>
              <div className={`text-lg font-semibold ${m.color}`}>{m.value}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Performance comparison */}
      <div className="bg-[#181825] border border-white/[0.06] rounded-lg p-4">
        <h4 className="text-xs font-medium text-gray-400 uppercase tracking-wide mb-2">
          Live vs Expected
        </h4>
        <div className="grid grid-cols-3 gap-3">
          {[
            { label: 'Win Rate', expected: '40.0%', actual: '41.7%', ok: true },
            { label: 'Sharpe', expected: '1.00', actual: '1.12', ok: true },
            { label: 'Max DD', expected: '21.9%', actual: '14.2%', ok: true },
          ].map((m) => (
            <div key={m.label} className="px-2 py-1.5">
              <div className="text-[9px] text-gray-500 uppercase tracking-wider mb-1">{m.label}</div>
              <div className="text-xs text-gray-400">Expected: {m.expected}</div>
              <div className={`text-sm font-medium ${m.ok ? 'text-emerald-400' : 'text-rose-400'}`}>
                Actual: {m.actual}
              </div>
            </div>
          ))}
        </div>
        <div className="mt-2 text-[11px] text-emerald-400">
          Within expected range
        </div>
      </div>
    </div>
  </div>
);

export default AdaptiveFlowMonitorMock;
